import { graphql, useStaticQuery } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';

export type CarouselImageFileNode = {
  relativePath: string;
  publicURL: string;
  childImageSharp?: {
    gatsbyImageData: IGatsbyImageData;
  };
};

// Everything in src/images/, keyed by filename later so JSON content can
// reference a slide by name (e.g. "woodlandhero.jpg" or "amp-demo.mp4")
// without knowing anything about Gatsby's GraphQL layer. Video files have no
// childImageSharp (sharp doesn't process video) but always have a publicURL.
const carouselImagesQuery = (): CarouselImageFileNode[] => {
  const data = useStaticQuery(graphql`
    query CarouselImagesQuery {
      allFile(filter: { sourceInstanceName: { eq: "images" } }) {
        nodes {
          relativePath
          publicURL
          childImageSharp {
            gatsbyImageData(width: 600, height: 320)
          }
        }
      }
    }
  `);
  return data.allFile.nodes;
};

export { carouselImagesQuery };
